import { render } from "./Advice.vue?vue&type=template&id=57c38ab7&scoped=true"
import script from "./Advice.vue?vue&type=script&lang=js"
export * from "./Advice.vue?vue&type=script&lang=js"

import "./Advice.vue?vue&type=style&index=0&id=57c38ab7&lang=scss&scoped=true"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57c38ab7"]])

export default __exports__